import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { NavMenuItem } from '../../shared/viewmodels/NavMenuItem';
import { NavMenuService } from '../../shared/services/nav-menu-service';

@Component({
  selector: 'app-nav-menu-item',
  templateUrl: './nav-menu-item.component.html',
  styleUrls: ['./nav-menu-item.component.css']
})
export class NavMenuItemComponent implements OnInit {
  @Input() Item: NavMenuItem;
  @Input() DataParent: string;
    renderer: Renderer2;
    nav: any;

  constructor(service: NavMenuService) {
    this.nav = service;
  }
  //toggleCollapsed() {
  //  console.log('Click worked');
  //  console.log(this.nav.isShown);
  //  this.nav.isShown = false;
  //  //this.isShown = true;
  //  //this.collapse = !this.collapse;
  //  console.log(this.nav.isShown);
  //  this.nav.toggleMenu = this.nav.isShown;
  //}

  expandMenu(name) {
    console.log('active menu' + name);

    this.nav.navItems.forEach(function(value) {
        console.log(value.name + value.isActive);
        if (value.isActive) {
          value.isActive = false;
          console.log('prev acive' + value.name);
        }
        if (value.name == name) {
          value.isActive = true;
          console.log('new active' + value.name + value.isActive);
        }

      }
    );

  }

  ngOnInit() {

  }

}
